// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDialog-MDCDialog_cls1__jvErd","cls2":"VeloDialog-MDCDialog_cls2__R2ncb VeloDialog-MDCDialog_cls1__jvErd"};